import { SVGInterface } from "../../interface";

const WarningFilled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2659 20.9979H2.73288C2.37562 20.9979 2.04551 20.8073 1.86688 20.4979C1.68825 20.1885 1.68825 19.8073 1.86688 19.4979L11.1329 3.49787C11.3117 3.18898 11.6415 2.99878 11.9984 2.99878C12.3553 2.99878 12.6851 3.18898 12.8639 3.49787L22.1299 19.4979C22.3084 19.8071 22.3085 20.1881 22.1301 20.4974C21.9518 20.8068 21.623 20.9975 21.2659 20.9979ZM10.9998 15.9999H12.9998V17.9999H10.9998V15.9999ZM12.9948 14.9988H10.9948V9.9978H12.9948V14.9988Z"
      fill={color || "#1C2B36"}
    />
  </svg>
);

export default WarningFilled;
